module.exports = __webpack_public_path__ + "static/img/tecdefault.6c722b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/tecdefault.png
// module id = 6xhw
// module chunks = 0